import { type AgentSessionResponse } from '@air/server-sdk';

import { isRenderableElicitation } from '~/components/v2/components/workspace/workspace-agent-panel/schemas/elicitation';

export type WorkspaceAgentSessionNeedsAttentionSession = Pick<AgentSessionResponse, 'status' | 'pendingElicitations'>;

/**
 * Orange dot on a task row when the thread needs user attention.
 * Unlike the prototype task list, the panel keeps `sessionId` while browsing My Tasks, so we do
 * not hide the dot on the active row — the header already signals selection; the row dot signals
 * that this thread still needs a response.
 */
export const isWorkspaceAgentSessionNeedsAttention = (session: WorkspaceAgentSessionNeedsAttentionSession): boolean => {
  if (session.status === 'archived') {
    return false;
  }

  if (session.status === 'inputRequested') {
    return true;
  }

  for (const raw of session.pendingElicitations ?? []) {
    if (isRenderableElicitation(raw)) {
      return true;
    }
  }

  return false;
};
